import React, { useState, useEffect } from 'react';
import './UpcomingPlanModal.css';
import { IoClose } from "react-icons/io5";
import PackageLaedFormComp from '../../Components/Table_booking/PackageLaedFormComp';

const UpcomingPlanModal = ({ isOpen, onClose, selectedLead }) => {
    if (!isOpen) return null;

    return (
        <div className="upm-custom-modal-overlay">
            <div className="upm-custom-modal">
                <div className='upm-update-lead-form-section'>
                    <div className='upm-update-lead-form-header'>
                        <div onClick={onClose} className='upm-update-lead-form-close'><IoClose color="red" /></div>
                    </div>
                    {/* <h4 className='update-lead-form-title'>Update Lead</h4> */}
                    <div className='upm-update-lead-form'>
                    <PackageLaedFormComp selectedLead={selectedLead} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpcomingPlanModal;
